import React from 'react';
import { Page } from '../Page';
import { Zap, Heart, Brain } from 'lucide-react';
export function SupplementCoQ10() {
  return <Page pageNumber={16} variant="light" data-id="element-2192">
      <div className="flex h-full gap-10" data-id="element-2193">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-2194">
          <img src="https://cdn.magicpatterns.com/uploads/t2rnxGtAEqZJZyXdw5PAnf/pasted-image.png" alt="Thorne CoQ10" className="w-full max-w-[280px] object-contain" data-id="element-2195" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-2196">
          <div className="mb-6 pt-4" data-id="element-2197">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-2198">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-2199">
              CoQ10
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-2200">
              Cellular energy + cardiovascular protection
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-2201" />
          </div>

          <div className="mb-8" data-id="element-2202">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-2203">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-2204">
              Cellular energy production becomes critical when caloric intake
              drops. CoQ10 fuels the mitochondria that power your heart, brain,
              and muscles. It also provides antioxidant protection during the
              metabolic stress of rapid weight loss and supports cardiovascular
              health, important since many GLP-1 patients have cardiometabolic
              risk factors.
            </p>
          </div>

          <div className="mb-8" data-id="element-2205">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-2206">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-2207">
              <li className="flex gap-2" data-id="element-2208">
                <Heart className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2209" />
                <span data-id="element-2210">
                  Supports heart health and cardiovascular function during
                  weight loss
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2211">
                <Zap className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2212" />
                <span data-id="element-2213">
                  Maintains cellular energy production during caloric deficit
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2214">
                <Brain className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-2215" />
                <span data-id="element-2216">
                  Provides antioxidant support for brain function and cognitive
                  health
                </span>
              </li>
              <li className="flex gap-2" data-id="element-2217">
                <span className="text-tealslate shrink-0" data-id="element-2218">•</span>
                <span data-id="element-2219">
                  Proprietary well-absorbed form with lycopene + turmeric, NSF
                  Certified
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-2220">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-2221">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-2222">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-2223">
                <strong data-id="element-2224">1-2 gelcaps daily</strong> with a meal containing fat
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-2225">
                100mg CoQ10 per gelcap • 60 gelcaps per bottle
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-2226">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-2227" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-2228">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}